import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { Dialog } from "../types";

export const accountSetting = "/account-setting/";
export const accountSettingDetailPath = (id: string) =>
  urlJoin(accountSetting, id);

export type AccountSettingDetailsUrlDialog = "change-password";

export type AccountSettingDetailsUrlQueryParams = Dialog<
  AccountSettingDetailsUrlDialog
>;

export const accountSettingDetailsUrl = (
  id: string,
  params?: AccountSettingDetailsUrlQueryParams
) =>
  accountSettingDetailPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
